﻿import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Component({

    moduleId: module.id,
    template:
     `
      <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
        <a class="navbar-brand" href="#">
          <img src="https://getbootstrap.com/docs/4.3/assets/brand/bootstrap-solid.svg" width="30" height="30" class="d-inline-block align-top" alt="">
          JuJu
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active" style="border-style: dashed;border-color: white;border-width: 1px;">
              <a class="nav-link" [routerLink]="'/login'" style="color: #00b0ff">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="'/register'" style="color: #00b0ff">Register</a>
            </li>
          </ul>
          <form class="form-inline my-2 my-lg-0">
            <button type="button"  style="margin-right: 10px;" class="btn btn-outline-info my-2 my-sm-0" *ngFor="let lang of supportedLanguages" [class.active]="isCurrentLang(lang.value)">
              <a (click)="selectLang(lang.value)"><span class="flag-icon flag-icon-{{lang.value==='en'?'us':'fr'}}"> </span></a>
            </button>
          </form>
        </div>
      </nav>
      <div class="container">
        <div class="row">
          <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5 blurred-box">
              <div class="card-body">
                  <img class="imageLogo" src="../../assets/images/logoNomadLogic.png">
                  <div class="parent">
                      <img class="image1" src="../../assets/images/user.png">
                      <img class="image2" src="../../assets/images/Blue.png">
                  </div>
                <form class="form-signin" accept-charset="UTF-8" name="form" (ngSubmit)="f.form.valid && login() " #f="ngForm">
                  <div class="form-label-group">
                    <input type="email" id="inputEmail" class="form-control" placeholder="Email address" autofocus  name="username"
                             [(ngModel)]="model.username" #username="ngModel" required>
                    <label for="inputEmail">Email address</label>
                  </div>

                  <div class="form-label-group">
                    <input type="password" id="inputPassword" class="form-control"  autocomplete="off" name="password"
                           placeholder="{{'password'|translate}}" [(ngModel)]="model.password" #password="ngModel" required>
                    <label for="inputPassword">Password</label>
                  </div>

                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                    <label class="custom-control-label" for="customCheck1">Remember password</label>
                  </div>
                  <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit">Sign in</button>
                  <button class="btn btn-lg btn-dark btn-block text-uppercase" (click)="register()" type="button">Register</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <generic-info-modal [hide]="hideErrorModal" [title]="errorModalTitle" [text]="errorModalText" [statusCode]="500"
                          (OkClick)="onOk()"></generic-info-modal>\``,
  styles: [`
      body {background: #007bff;background: linear-gradient(to right, #0062E6, #33AEFF);-webkit-font-smoothing: antialiased; }

      .parent {
          position: relative;
          top: 0;
          left: 70px;
          margin-bottom: 50px;
      }
      .image1 {
          position: relative;
          top:30px;
          left: 30px;
          height:160px;width: 160px;
      }
      .image2 {
          position: absolute;
          top: 0;
          left: 0;
          height:220px;width: 220px;
      }

      .blurred-box{
          position: relative;
          background: inherit;
          border-radius: 2px;
          overflow: hidden;
      }

      .blurred-box:after{
          content: '';
          background: inherit;
          position: absolute;
          right: 0;
          bottom: 0;
          box-shadow: inset 0 0 0 200px rgba(255,255,255,0.05);
          filter: blur(50px);
      }
  `]
})

export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';

    hideErrorModal = true;
    errorModalTitle = 'Login Error';
    errorModalText = 'An error has occurred during authentication.\n ERROR: 0x3C Database connectivity failed!';

    private supportedLanguages: any[];
    constructor(
        private router: Router,
        private _authenticationService: AuthenticationService) { }

    ngOnInit() {
        // reset login status
        this._authenticationService.logout();
        // standing data
        this.supportedLanguages = [
            { display: 'English', value: 'en' },
            { display: 'Français', value: 'fr' }
        ];

        if (localStorage.getItem('language')) {
            this.selectLang(localStorage.getItem('language'));
        } else {
            this.selectLang('en');
        }

    }



    isCurrentLang(lang: string) {
        // return lang === this._translate.currentLang;
    }

    selectLang(lang: string) {
        console.log(lang);
        // set default;
        localStorage.setItem('language', lang);

    }



    login() {

        this.loading = true;
        this._authenticationService.login(this.model.username, this.model.password)
            .subscribe((result: boolean) => {
                if (result) {
                    // localStorage.setItem("Authorization", result.headers.get("Authorization"));
                    console.log(result);
                    this.router.navigate(['/main']);
                } else {
                    this.error = 'Username or password is incorrect';
                    console.log(result);
                    this.loading = false;
                }
            },
            err=> {this.hideErrorModal = false;});
    }

  register() {
    this.router.navigate(['/register']);
  }

    onOk() {
        this.hideErrorModal = true;
    }
}
